import React from 'react';

import classnames from 'classnames';

import './ProfileButton.scoped.scss';

interface Props {
  open?: boolean;
  onClick?: () => void;
}

const ProfileButton: React.FC<Props> = ({ open = false, onClick }) => {
  return (
    <div className={classnames({ 'profile-button': true, open })} onClick={onClick}>
      <div />
      <div />
      <div />
    </div>
  );
};

export default ProfileButton;
